<script setup>
const props = defineProps({
  kenteken: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <BaseInput
    name="reportCode"
    :label="$t('almost-insured.reportCodeTitle')"
    :placeholder="$t('almost-insured.reportCodeTitle')"
    validation-visibility="blur"
    :validation="`required|length:4,4|alpha_num|*checkReportCode:${props.kenteken}`"
    maxlength="4"
  />
</template>
